import React from 'react';
import { Grid, makeStyles, Typography } from '@material-ui/core';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import WorkOutlineIcon from '@material-ui/icons/WorkOutline';
import SignalCellularAltIcon from '@material-ui/icons/SignalCellularAlt';
import StarsIcon from '@material-ui/icons/Stars';

const useStyles = makeStyles({
  NotificationContainer: {
    padding: '10px 3.5px 20.5px 13px',
    borderBottom: '1px solid rgba(0, 0, 0, 0.2)',
  },
  date: {
    color: '#a4a8ac',
    textAlign: 'right',
    fontSize: '12px',
    fontWeight: 'normal',
    LineWeight: 1.67,
    letterSpacing: '0.22px',
    marginBottom: '3px',
  },
  icon: {
    background: '#fdd6be',
    height: '24px',
    width: '24px',
    padding: '4px',
    borderRadius: '100%',
    marginRight: '15.5px',
  },
  detailsContainer: {
    display: 'flex',
    alignItems: 'end',
  },
  notificationText: {
    fontWeight: 'normal',
    fontSize: '14px',
    lineHeight: 1.43,
    letterSpacing: '0.25px',
    color: '#49515a',
    marginBottom: '10px',
  },
  link: {
    color: '#4b8c6f',

    '&:visited': {
      color: '#4b8c6f',
    },
  },
  missingField: {
    marginLeft: '36px',
    display: 'flex',
    alignItems: 'center',
    padding: '6px 0',
    color: '#49515a',
    fontSize: '14px',
    lineHeight: 1.43,
    letterSpacing: '0.25px',
  },
  missingFieldIcon: {
    marginRight: '17.5px',
    height: '24px',
    width: '24px',
  },
});

export const MissingJobFieldsNotification = ({ notification = {} }) => {
  const classes = useStyles();
  const { time, jsonMessage } = notification;
  const url = `${window.location.origin}/job/${jsonMessage.jobId}/edit`;

  const renderField = (field) => {
    const ICON_MAPPING = {
      'Job Title': WorkOutlineIcon,
      Experience: SignalCellularAltIcon,
      Skills: StarsIcon,
    };

    const Icon = ICON_MAPPING[field];

    return (
      <Typography classes={{ root: classes.missingField }}>
        {Icon && <Icon classes={{ root: classes.missingFieldIcon }} />}
        {field}
      </Typography>
    );
  };

  return (
    <Grid item xs={12} classes={{ root: classes.NotificationContainer }}>
      <Typography classes={{ root: classes.date }}>{time}</Typography>
      <div className={classes.detailsContainer}>
        <ErrorOutlineIcon classes={{ root: classes.icon }} />
        <div className={classes.notificationText}>
          We have found few Missing fields in{' '}
          <a
            href={url}
            target="_blank"
            rel="noreferrer"
            className={classes.link}
          >
            {jsonMessage.jobRole}
          </a>
          . Please update so that we can find the relevant candidate.
        </div>
      </div>
      <div className={classes.skillsContainer}>
        {jsonMessage.missingFields.map((field) => renderField(field))}
      </div>
    </Grid>
  );
};
